(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["hoverstone-model-studio"] && !Shopify.designMode) return;
  try {
    
  if (!customElements.get('hoverstone-spin')) {
    customElements.define('hoverstone-spin', class HoverstoneSpin extends HTMLElement {
      connectedCallback() {
        this.object = this.querySelector('[data-spin-object]');
        this.stage = this.querySelector('[data-spin-stage]');
        this.angle = 0;
        this.dragging = false;
        this.auto = false;
        this.frame = null;
        this.lastX = 0;
        this.modelViewer = this.querySelector('model-viewer');

        this.querySelector('[data-spin-auto]')?.addEventListener('click', () => this.toggleAuto());
        this.querySelector('[data-spin-reset]')?.addEventListener('click', () => this.reset());

        this.modelViewer?.addEventListener('load', () => this.configureModel());
        if (this.modelViewer?.loaded) this.configureModel();

        if (!this.object || !this.stage) return;
        this.stage.addEventListener('pointerdown', (event) => this.startDrag(event));
        this.stage.addEventListener('pointermove', (event) => this.drag(event));
        this.stage.addEventListener('pointerup', () => this.endDrag());
        this.stage.addEventListener('pointercancel', () => this.endDrag());
      }

      disconnectedCallback() {
        cancelAnimationFrame(this.frame);
      }

      startDrag(event) {
        this.dragging = true;
        this.auto = false;
        this.lastX = event.clientX;
        this.stage.setPointerCapture(event.pointerId);
      }

      drag(event) {
        if (!this.dragging) return;
        this.angle += (event.clientX - this.lastX) * 0.35;
        this.lastX = event.clientX;
        this.render();
      }

      endDrag() {
        this.dragging = false;
      }

      toggleAuto() {
        if (this.modelViewer) {
          this.auto = !this.auto;
          this.modelViewer.toggleAttribute('auto-rotate', this.auto);
          return;
        }
        this.auto = !this.auto;
        if (this.auto) this.tick();
      }

      tick() {
        if (!this.auto) return;
        this.angle += 0.35;
        this.render();
        this.frame = requestAnimationFrame(() => this.tick());
      }

      reset() {
        this.auto = false;
        cancelAnimationFrame(this.frame);
        if (this.modelViewer) {
          this.modelViewer.removeAttribute('auto-rotate');
          this.modelViewer.cameraOrbit = '0deg 75deg 205%';
          this.modelViewer.cameraTarget = 'auto auto auto';
          this.modelViewer.jumpCameraToGoal?.();
          return;
        }
        this.angle = 0;
        this.render();
      }

      render() {
        if (this.object) this.object.style.setProperty('--hoverstone-spin-angle', `${this.angle}deg`);
      }

      configureModel() {
        if (!this.modelViewer) return;
        this.modelViewer.cameraOrbit = '0deg 75deg 205%';
        this.modelViewer.cameraTarget = 'auto auto auto';
        this.modelViewer.fieldOfView = '45deg';
        this.modelViewer.jumpCameraToGoal?.();
      }


    });
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["main-collection"]) return;
  try {
    
  const url = new URL(window.location.href);
  if (url.hash) {
    document.addEventListener(
      'DOMContentLoaded',
      () => {
        const card = document.getElementById(url.hash.slice(1));
        if (card) {
          card.scrollIntoView({ behavior: 'instant' });
        }
      },
      { once: true }
    );
  }

  } catch(e) { console.error(e); }
})();
})();
